import { render, staticRenderFns } from "./Niveles.vue?vue&type=template&id=f5c559d8&"
import script from "./Niveles.vue?vue&type=script&lang=js&"
export * from "./Niveles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports